import LegalLayout, { H2 } from "@/components/site/LegalLayout";
import { COMPANY } from "@/data/content";

export default function Impressum() {
  return (
    <LegalLayout title="Impressum" description="Impressum der Schössow Dienstleistungen UG – Hausnotruf Dortmund.">
      <H2>Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)</H2>
      <p>
        {COMPANY.name}<br />
        {COMPANY.street}<br />
        {COMPANY.zip} {COMPANY.city}
      </p>

      <H2>Vertreten durch</H2>
      <p>Die Geschäftsführung der {COMPANY.name}.</p>

      <H2>Kontakt</H2>
      <p>
        Telefon: <a href={`tel:${COMPANY.phoneHref}`} className="underline">{COMPANY.phoneDisplay}</a><br />
        E-Mail: <a href={`mailto:${COMPANY.email}`} className="underline">{COMPANY.email}</a>
      </p>

      <H2>Registereintrag</H2>
      <p>Eingetragen im Handelsregister. Registergericht und Registernummer werden auf Anfrage mitgeteilt bzw. sind hier zu ergänzen: [HRB-Nummer / Amtsgericht].</p>

      <H2>Umsatzsteuer-ID</H2>
      <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: [USt-IdNr. hier eintragen].</p>

      <H2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</H2>
      <p>{COMPANY.name}, {COMPANY.street}, {COMPANY.zip} {COMPANY.city}.</p>

      <H2>Streitschlichtung</H2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
        {" "}<a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="underline">https://ec.europa.eu/consumers/odr/</a>.
        Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </p>

      <H2>Haftung für Inhalte</H2>
      <p>Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.</p>

      <H2>Haftung für Links</H2>
      <p>Unser Angebot enthält ggf. Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.</p>

      <H2>Urheberrecht</H2>
      <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet.</p>

      <p className="text-sm italic">Hinweis: Bitte ergänzen Sie die mit […] markierten Angaben (HRB-Nummer, Amtsgericht, USt-IdNr.) mit Ihren offiziellen Firmendaten.</p>
    </LegalLayout>
  );
}
